/**
 * Main App component for Debt Calculator
 * Constitutional requirement: React with regular JavaScript, console logging
 */

import React, { useEffect } from 'react'
import Navigation from './components/Navigation.jsx'
import Hero from './components/Hero.jsx'
import Calculator from './components/Calculator.jsx'
import HowItWorks from './components/HowItWorks.jsx'
import EducationalContent from './components/EducationalContent.jsx'
import FAQ from './components/FAQ.jsx'
import AboutPage from './components/AboutPage.jsx'
import ContactPage from './components/ContactPage.jsx'
import PrivacyPolicy from './components/PrivacyPolicy.jsx'
import Footer from './components/Footer.jsx'
import BackgroundAnimation from './components/BackgroundAnimation.jsx'
import './styles.css'

// Import test utility in development mode
// if (import.meta.env.DEV) {
//   import('./utils/test.js').then(({ initializeApplicationTests }) => {
//     initializeApplicationTests()
//   }).catch(error => {
//     console.log('⚠️ Could not load test utility:', error)
//   })
// }

function App() {

  useEffect(() => {
    console.log('🌐 Environment:', import.meta.env.MODE)
    console.log('🔧 Development mode:', import.meta.env.DEV)
  }, [])

  return (
    <div className="app">
      <BackgroundAnimation />
      <Navigation />
      <Hero />
      <section id="calculator">
        <Calculator />
      </section>
      <HowItWorks />
      <EducationalContent />
      <FAQ />
      <AboutPage />
      <ContactPage />
      <PrivacyPolicy />
      <Footer />
    </div>
  )
}

export default App
